import React, { useRef } from 'react'
import { Grid } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import { GridColumns } from '@mui/x-data-grid-pro';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';

const CpnListProductService = (props) => {
    const { 
        DataRowProductService, 
    } = props;

    const dataColumn: GridColumns = [
        {
            field: "sID",
            headerName: "ที่",
            headerAlign: "center",
            width:40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sTitle",
            headerName: "ผลิตภัณฑ์และบริการ",
            headerAlign: "center",
            flex: 4,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
        },
    ];


    return (
        <>
            <Accordion header={"ข้อมูลผลิตภัณฑ์และบริการที่สนใจ"}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                    <Grid item xs={12} >
                        <DataGridMuiClient
                            isLoading={false}
                            rows={DataRowProductService}
                            HiddenToolHead={true}
                            Columns={dataColumn}
                            backgroundHeaderCustom={"#004290"}
                            sxCustomHeader={{ color: '#ffffff' }}
                            hideFooter={true}
                        />
                    </Grid>
                </Grid>
            </Accordion>
        </>
    )
}

export default CpnListProductService